<div data-test="container-grafico-fichas-por-pdv">
    <div class="chart-axis-wrap chart-axis-wrap-top" *ngIf="hasData">
        <canvas #topAxisCanvas data-test="grafico-fichas-por-pdv-eixo-topo" baseChart
            [data]="axisChartData"
            [options]="topAxisOptions"
            [type]="'bar'">
        </canvas>
    </div>
    <div class="chart-scroll" *ngIf="hasData">
        <div class="chart-canvas-wrap" [style.height.px]="chartHeight">
            <canvas #barsCanvas data-test="grafico-fichas-por-pdv" baseChart
                [data]="barChartData"
                [options]="barChartOptions"
                [plugins]="barChartPlugins"
                [type]="'bar'">
            </canvas>
        </div>
    </div>
    <div class="chart-axis-wrap" *ngIf="hasData">
        <canvas #bottomAxisCanvas data-test="grafico-fichas-por-pdv-eixo-base" baseChart
            [data]="axisChartData"
            [options]="bottomAxisOptions"
            [type]="'bar'">
        </canvas>
    </div>
    <div class="chart-legend" data-test="legenda-grafico-fichas-por-pdv" *ngIf="hasData">
        <span data-test="item-legenda-grafico-fichas-por-pdv-fichas" class="chart-legend-item">
            <span class="chart-legend-dot chart-legend-dot-tickets"></span>
            {{ 'consumptionTicketSales.dashboard.ticketsIssued' | translate }}
        </span>
        <span data-test="item-legenda-grafico-fichas-por-pdv-vendas" class="chart-legend-item">
            <span class="chart-legend-dot chart-legend-dot-sales"></span>
            {{ 'consumptionTicketSales.dashboard.salesCount' | translate }}
        </span>
    </div>
    <p data-test="mensagem-sem-dados-grafico-pdv" class="no-sales" *ngIf="!hasData">{{ 'consumptionTicketSales.dashboard.noData' | translate }}</p>
</div>
